<template>
  <div class="card-base">
    <a :href="cardLink" class="card-router">
      <section class="card-base-section card-shade card-hover">
        <div class="card-base-title">
          <img :src="require(`@/assets/images/${imageSource}`)" alt="">
          <h2>{{ cardTitle }}</h2>

        </div>

        <hr class="hr-grey">

        <div class="card-base-text">
          <p>{{ cardText }}</p>
        </div>
      </section>
    </a>
  </div>
</template>

<script>

export default {
  name: 'CardBase',
  props: {
    cardLink: String,
    cardTitle: String,
    cardText: String,
    imageSource: String,
    btn: String,
    msg: String
  }
}
</script>

<style scoped lang="scss">

.card-base {
  .card-router {
    cursor: pointer;
    text-decoration: none;
    color: #666666;
  }

  .card-base-section {
    max-width: 280px;
    margin: 20px;
    background-color: white;
    border-radius: 8px;
    & > div {
      transition-duration: 0.3s;

      text-align: center;

      & > h1 {
        padding: 0 0 0 0;
      }

      & > span {
        font-size: 2.5em;
      }

      & > u {
        font-size: 1.5em;
        vertical-align: 0.5em;
      }

      & > p {
        font-size: 1.1em;
        padding: 0 10px;
      }

    }
  }

  .card-base-title {
    & > h2 {
      margin: 0;
      padding: 0 0 20px;
    }

    & > hr {
      border-top: 1px solid #DFE5FC;
    }

    & > img {
      padding: 20px 0 10px;
      width: 50px;
      filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.15));
    }
  }

  .card-base-text {
    padding: 10px 0;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    background: #FAFAFA;
  }

  .hr-grey {
    color: #DFE5FC;
    width: 100%;
    margin: 0;
  }
}

@media (max-width: 830px) {
  .card-base {
    .button-secondary {
      width: 330px;
    }

    .button-primary-blue {
      width: 330px;
    }

    .card-link-base-section {
      max-width: 400px;
      background-color: white;
      border-radius: 10px;
      box-shadow: 0 2px 43px -4px rgba(0, 0, 0, .1);

      .card-link-base-text {
        height: 280px;
        padding: 35px 0;
      }

      & > section {
        transition-duration: 0.3s;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        text-align: center;

        & > h1 {
          padding: 10px 0 0 0;
        }
      }
    }

    .card-link-base-cta {
      height: 220px;
    }
  }
}
</style>
